import React, { Component } from 'react';
import i from '../imports';


class IconsWithText extends Component {

    render() {
        let iconsTextMap = this.props.data;

        return (
            <div>
            <i.Grid container spacing={24} style={{padding: "20px 10px"}}>
                {iconsTextMap.map( m => 
                    <i.Grid container style={{marginBottom : "10px"}}>
                        <i.Grid item xs={2} className="content-icon" >
                            <div>{m.icon !== undefined ? <i.Icon icon={m.icon} size="32"/> : null}</div>
                        </i.Grid>
                        <i.Grid item xs={10} className="content-text" style={{paddingTop: "1%"}}>
                            <div>{m.text}</div>
                            
                        </i.Grid>
                    </i.Grid>
                )}
            </i.Grid>
            </div>
        );
    }
}

export default IconsWithText;